document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.getElementById('cm-bundle-drawer');
  if (!drawer) return;

// --- 1. UI LOGIK (Oversigt, Vest & Pris) ---
function cmUpdateUI() {
  const selected = drawer.querySelectorAll('.cm-size-button.is-selected');
  const summaryText = drawer.querySelector('.cm-footer-selected-items');
  const summaryRow = drawer.querySelector('.cm-footer-selection-summary');
  const priceDisplay = document.getElementById('cm-total-price-display');
  const vestActive = document.getElementById('cm-vest-content')?.style.display !== 'none';

  let names = [];
  selected.forEach(btn => {
    const parent = btn.closest('.cm-bundle-item');
    if (parent && parent.style.display !== 'none') {
      const fullName = parent.querySelector('.cm-bundle-item__name').textContent.trim();
      const size = btn.querySelector('.cm-size-button__val').textContent.trim();
      
      // Lav "Suit pants" eller "buks" om til "Bukser" – ellers brug det første ord (f.eks. Blazer)
      let name = fullName.toLowerCase().includes('pants') || fullName.toLowerCase().includes('buks') 
        ? 'Bukser ·' 
        : fullName.toLowerCase().includes('gavekort') 
        ? 'Gavekort ·' 
        : fullName.split(' ')[0];

      names.push(`${name} (${size})`);
    }
  });

  if (summaryText) summaryText.textContent = names.join(' · ');
  if (summaryRow) summaryRow.style.display = names.length > 0 ? 'flex' : 'none';

if (priceDisplay) {
    const base = parseInt(priceDisplay.dataset.basePrice);
    const vest = vestActive ? parseInt(priceDisplay.dataset.vestPrice || 0) : 0;
    const totalPrice = (base + vest) / 100;

    const formattedPrice = new Intl.NumberFormat('da-DK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(totalPrice);

    priceDisplay.textContent = `${formattedPrice} DKK`;
  }
}

// --- 2. SIZE FINDER RESULTATER (Med korrigerede HTML-værdier) ---
  document.addEventListener('cm:sizefinder:result', function(e) {
    const results = e.detail;
    const items = drawer.querySelectorAll('.cm-bundle-item');
    
    items.forEach(item => {
      const nameEl = item.querySelector('.cm-bundle-item__name');
      const recEl = item.querySelector('.cm-bundle-item__recommended strong');
      if (!nameEl || !recEl) return;
      
      const name = nameEl.textContent.toLowerCase();
      let recommendedSize = '--';
      let recommendedFit = null;

      if (name.includes('jakke') || name.includes('blazer')) {
        recommendedSize = results.blazer;
      } else if (name.includes('buks') || name.includes('pants')) {
        recommendedSize = results.pants;
        
        const rawFit = results.pantsFit ? results.pantsFit.toLowerCase() : '';
        
        // Matcher dine præcise data-fit-value attributter fra HTML'en
        if (rawFit === 'slim' || rawFit === 'straight') {
          recommendedFit = 'Straight fit';
        } else if (rawFit === 'regular' || rawFit === 'loose') {
          recommendedFit = 'Regular fit';
        }
      } else if (item.classList.contains('cm-vest-item') || name.includes('vest')) {
        recommendedSize = results.vest;
      }

      // Opdater tekst-anbefalingen i UI
      recEl.textContent = recommendedSize || '--';

      // Hvis der er et anbefalet fit (for bukser), aktiverer vi det først
      if (recommendedFit) {
        const fitBtn = item.querySelector(`.cm-fit-button[data-fit-value="${recommendedFit}"]`);
        if (fitBtn) {
          // Fjern aktiv klasse fra de andre fit-knapper
          item.querySelectorAll('.cm-fit-button').forEach(b => b.classList.remove('is-active'));
          // Gør den korrekte fit-knap aktiv (fha. classList.add)
          fitBtn.classList.add('is-active');
          
          // Vis kun de matchende størrelsesknapper for dette fit
          item.querySelectorAll('.cm-size-button').forEach(sb => {
            sb.style.display = sb.dataset.fit === recommendedFit ? 'flex' : 'none';
            if (sb.dataset.fit !== recommendedFit) sb.classList.remove('is-selected');
          });
        }
      }

      // AUTOMATISK PRESELECT AF STØRRELSE
      if (recommendedSize && recommendedSize !== '--') {
        const sizeButtons = item.querySelectorAll('.cm-size-button');
        
        sizeButtons.forEach(btn => {
          const sizeValEl = btn.querySelector('.cm-size-button__val');
          if (!sizeValEl) return;

          const buttonSize = sizeValEl.textContent.trim().toLowerCase();
          const targetSize = recommendedSize.toString().trim().toLowerCase();

          // Hvis der er et match, og knappen er synlig under det valgte fit
          if (buttonSize === targetSize && !btn.disabled && btn.style.display !== 'none') {
            item.querySelectorAll('.cm-size-button').forEach(b => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');
          }
        });
      }
    });

    // Opdater priser og bunden af draweren
    cmUpdateUI();
  });

  // --- 3. CLICK HANDLERS (Navigation & Valg) ---
  drawer.addEventListener('click', function(e) {
    // Åbn Size Finder
    if (e.target.closest('.cm-size-finder-trigger')) {
      const sfContainer = document.getElementById('cm-sizefinder-container');
      if (sfContainer) sfContainer.style.display = 'block';
      return;
    }

    // Luk Size Finder
    if (e.target.id === 'cm-close-sizefinder') {
      const sfContainer = document.getElementById('cm-sizefinder-container');
      if (sfContainer) sfContainer.style.display = 'none';
      return;
    }

    const btn = e.target.closest('button');
    if (!btn) return;

    // Pasform knapper
    if (btn.classList.contains('cm-fit-button')) {
      const p = btn.closest('.cm-bundle-item');
      p.querySelectorAll('.cm-fit-button').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const val = btn.dataset.fitValue;
      p.querySelectorAll('.cm-size-button').forEach(sb => {
        sb.style.display = sb.dataset.fit === val ? 'flex' : 'none';
        if (sb.dataset.fit !== val) sb.classList.remove('is-selected');
      });
    }

    // Størrelse knapper
    if (btn.classList.contains('cm-size-button') && !btn.disabled) {
      btn.closest('.cm-bundle-item').querySelectorAll('.cm-size-button').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
    }

    // Fjern vest knap
    if (btn.id === 'cm-remove-vest-btn') {
      document.getElementById('cm-vest-content').style.display = 'none';
      document.getElementById('cm-vest-toggle-bar').style.display = 'flex';
    }

    cmUpdateUI();
  });

  // Tilføj vest (fra div-baren)
  document.getElementById('cm-vest-toggle-bar')?.addEventListener('click', function() {
    document.getElementById('cm-vest-content').style.display = 'block';
    this.style.display = 'none';
    cmUpdateUI();
  });

  // --- 4. DEN RIGTIGE AURORA ATC-INTEGRATION ---
  const submitBtn = document.getElementById('cm-submit-bundle');
  if (submitBtn) {
    submitBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const selected = Array.from(drawer.querySelectorAll('.cm-bundle-item'))
        .filter(row => row.style.display !== 'none')
        .map(row => row.querySelector('.cm-size-button.is-selected'))
        .filter(btn => btn !== null);

      const totalRows = Array.from(drawer.querySelectorAll('.cm-bundle-item'))
        .filter(row => row.style.display !== 'none').length;

      if (selected.length < totalRows) {
        alert('Vælg venligst størrelse til alle dele.');
        return;
      }

      submitBtn.disabled = true;
      const originalBtnText = submitBtn.querySelector('.cm-atc-text').textContent;
      submitBtn.querySelector('.cm-atc-text').textContent = 'Tilføjer...';

      let auroraForm = document.querySelector('product-form form');
      if (!auroraForm) {
        window.location.reload();
        return;
      }

      // Rens og indsæt i Aurora-formen
      auroraForm.querySelectorAll('.cm-temp-input').forEach(i => i.remove());
      selected.forEach((btn, index) => {
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = `items[${index}][id]`;
        idInput.value = btn.dataset.variantId;
        idInput.className = 'cm-temp-input';
        auroraForm.appendChild(idInput);
        
        const qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = `items[${index}][quantity]`;
        qtyInput.value = "1";
        qtyInput.className = 'cm-temp-input';
        auroraForm.appendChild(qtyInput);
      });

      // Send via Aurora's system
      const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      auroraForm.dispatchEvent(submitEvent);

      setTimeout(() => {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
        submitBtn.disabled = false;
        submitBtn.querySelector('.cm-atc-text').textContent = originalBtnText;
        auroraForm.querySelectorAll('.cm-temp-input').forEach(i => i.remove());
      }, 1000);
    });
  }

  // Luk Bundle Drawer
  const closeEls = [drawer.querySelector('.cm-bundle-drawer__close'), drawer.querySelector('.cm-bundle-drawer__overlay')];
  closeEls.forEach(el => el?.addEventListener('click', () => {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }));
});